/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Account Info MultiBalances Styled Component
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.11.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

export const AccountInfoMultiBalancesListStyled = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    margin-bottom: -20px; // *
`;

export const AccountInfoMultiBalancesListItemStyled = styled.div`
    flex-basis: 387px;

    margin-right: 20px;
    margin-bottom: 20px; // *

    background: ${colors.textColorWhite};
    box-shadow: 0 2px 9px rgba(0, 0, 0, 0.15);
`;

export const AccountInfoMultiBalancesListItemTitleStyled = styled.div`
    background: ${colors.backgroundColorSuccess};

    padding: 20px 24px;

    h3 {
        ${fonts.textHeader3}
        color: ${colors.textColorWhite};
        margin: 0;
        max-width: 250px;
    }
`;

export const AccountInfoMultiBalancesListItemSubTitleStyled = styled.div`
    ${fonts.textSmall}
    color: ${colors.textColorWhite};
`;

export const AccountInfoMultiBalancesListItemBodyStyled = styled.div`
    padding: 20px;

    span.date-time {
        ${fonts.textSmall}
        color: ${colors.textColorOpacity};
    }
`;

export const AccountInfoMultiBalancesCollapseListItemStyled = styled.div`
    margin: 24px;

    h5 {
        margin: 0;
        ${fonts.textMainBold}
        color: ${colors.textLinkColor};
        cursor: pointer;
    }

    p {
        color: ${colors.textColorOpacity};
    }
`;

export const AccountInfoMultiBalancesEventsBalanceStyled = styled.span`
    color: ${colors.textColorSuccess};

    &.red {
        color: ${colors.textColorWarning};
    }
`;
